__turbopack_context__.v({
  "neotag": "NeoTag-module-sass-module__d19V9G__neotag" + " " + __turbopack_context__.i(91123)["linkSpan"],
});
